import { Grid, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React, { useEffect, useState } from 'react';
import DocumentMeta from 'react-document-meta';
import { useDispatch, useSelector } from 'react-redux';
import ReactGA from 'react-ga';
import HolderModal from '../../components/Modals/Holders Modal';
import WatchListAdd from '../../components/Modals/WatchListAdd';
import styles from './OptionsBoardStyles';
import { setOptionChainAction } from '../../actions/optionChainAction';
import LeftSidebar from './LeftSidebar';
import RightSidebar from './RightSidebar';
import MainSection from './MainSection';
import { setAppStateAction } from '../../actions/appStateAction';
import { fetchDataFunc, keyPressFunc } from '../../Shared';
import { useHistory } from 'react-router-dom';
import Loading from '../../components/Loading';

const DesktopView = ({ handleClickSnak, rows, changeBidAskMid }) => {
	const history = useHistory();
	const { appReducer, optionChainReducer } = useSelector((state) => state);
	const dispatch = useDispatch();
	const setAppState = (payload) => dispatch(setAppStateAction(payload));
	const setOptionChainState = (payload) =>
		dispatch(setOptionChainAction(payload));

	const {
		isMobile,
		userData,
		ticker,
		quoteInfo: { latestPrice },
		holderList,
	} = appReducer;

	const {
		snakOpen,
		snakMessage,
		alertType,
		watchListModal,
		watchListModalIndex,
		localTicker,
		selectedDate,
		holderModal,
	} = optionChainReducer;

	useEffect(() => {
		if (window.innerWidth < 1650 && window.innerWidth > 1401) {
			setOptionChainState({
				zoompercent: '88%',
				transformScale: 0.9,
			});
		} else if (window.innerWidth <= 1400 && window.innerWidth > 1280) {
			setOptionChainState({
				zoompercent: '80%',
				transformScale: 0.9,
			});
		} else if (window.innerWidth <= 1280 && window.innerWidth > 1200) {
			setOptionChainState({
				zoompercent: '72%',
				transformScale: 0.9,
			});
		} else if (window.innerWidth <= 1200 && window.innerWidth > 850) {
			setOptionChainState({
				zoompercent: '62%',
				transformScale: 0.9,
			});
		}

		return () => {
			setOptionChainState({
				zoompercent: '100%',
				transformScale: '1',
			});
		};
	}, [window.innerWidth]);

	const keyPress = (e) =>
		keyPressFunc(e, appReducer, setAppState, setOptionChainState, history);

	const [loading, setLoading] = useState(false);

	const changeExpiration = (expiration, date = '') => {
		setLoading(true);
		if (expiration === 'placeholder') return;
		setAppState({ expiration });
		fetchDataFunc(ticker, expiration, date, appReducer, setAppState);
		ReactGA.event({
			category: 'ChainAction',
			action: 'Changed expiration',
			label: `${ticker} by ${expiration}`,
		});
		setLoading(false);
	};
	const meta = {
		title: localTicker
			? `${localTicker} Options Chain - OptionsGeek`
			: 'Options Chain - OptionsGeek',
		description: `This ${localTicker} option chain tells you how to choose strike price for call options and put options. Live option chain with options volume vs open interest.`,
		canonical: 'https://tools.optionsgeek.com/optionschain',
		keywords:
			'option, chain, open, interest, vs, volume, strike, price, call, put, best, strike, price, live, implied, volatility, chart',
	};

	let lengthCheck = false;
	if (Object.keys(holderList).length > 0) {
		if (holderList.hieghestCalls.length || holderList.hieghestPuts.length) {
			lengthCheck = true;
		}
	}

	return (
		<DocumentMeta {...meta}>
			<div
				style={
					window.innerWidth < 1800
						? styles.containerSmaller
						: {
								...styles.container,
								margin: window.innerWidth > 2000 ? 'auto' : '',
								width: window.innerWidth > 2000 ? '1800px' : '',
						  }
				}
			>
				<Snackbar
					open={snakOpen}
					color='green'
					ContentProps={{
						sx: {
							background: 'green',
						},
					}}
					anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
					autoHideDuration={5000}
					onClose={() => dispatch(setOptionChainAction({ snakOpen: false }))}
					message={snakMessage}
				>
					<Alert
						onClose={() => dispatch(setOptionChainAction({ snakOpen: false }))}
						severity={alertType}
						sx={{ width: '100%' }}
					>
						{snakMessage}
					</Alert>
				</Snackbar>

				{watchListModal && watchListModalIndex.length > 0 ? (
					<WatchListAdd
						latestPrice={latestPrice}
						handleClickSnak={handleClickSnak}
						date={selectedDate}
						symbol={localTicker}
						showModal={watchListModal}
						isMobile={isMobile}
						setShowModal={() =>
							dispatch(setOptionChainAction({ watchListModal: false }))
						}
						watchListModalIndex={watchListModalIndex}
						userData={userData}
					/>
				) : null}
				{holderModal && lengthCheck && (
					<HolderModal
						showModal={holderModal}
						symbol={localTicker}
						setShowModal={() =>
							dispatch(setOptionChainAction({ holderModal: false }))
						}
					/>
				)}
				<div style={{ height: '100%', display: 'flex', flexDirection: 'row' }}>
					<LeftSidebar
						changeExpiration={changeExpiration}
						keyPress={keyPress}
					/>

					<div style={styles.visiblediv}>
						<Grid container spacing={0} style={{ height: '100%' }}>
							{loading ? (
								// <Lo>loading</Lo>
								<Loading />
							) : (
								<MainSection changeBidAskMid={changeBidAskMid} rows={rows} />
							)}
							<RightSidebar />
						</Grid>
					</div>
				</div>
			</div>
		</DocumentMeta>
	);
};

export default DesktopView;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/DesktopView.jsx